import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { getCosmicProducts } from './cosmic/fetchFunctions/getCosmicProducts'
import type { CMSResult } from './types/CMSError'
import type { CosmicProductType } from './cosmic/types/CosmicProductType'
import { logError } from '../utils/shared/log'

export type GetProductsPropsType = {
  locale: SupportedLocale
  limit?: number
}

export const getProducts = async ({
  locale,
  limit = 100,
}: GetProductsPropsType): Promise<CMSResult<CosmicProductType[] | null>> => {
  try {
    const cosmicProducts = await getCosmicProducts({
      limit,
      locale,
    })

    if (!cosmicProducts) {
      return {
        error: {
          code: 'COSMIC_PRODUCTS_MISSING',
          message:
            "We couldn't load the products at this time. Please refresh the page to try again.",
          source: 'cosmic',
          timestamp: new Date().toISOString(),
        },
      }
    }

    return cosmicProducts.items || null
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    const errorDetails = {
      code: 'COSMIC_PRODUCTS_FETCH_FAILED',
      message:
        "We're having trouble loading our product catalog. Please try again in a few moments.",
      source: 'cosmic' as const,
      details: errorMessage,
      timestamp: new Date().toISOString(),
    }

    logError('COSMIC: Error fetching cosmic grid page data:', errorDetails)

    return { error: errorDetails }
  }
}
